import React from "react";
import '../Styles/CampEventAndDateSelection.scss';
import DateHelpers from '../Helper/DateHelpers.js';
import EventCardList from "./EventCardList.js";
import { CombinationPageOptions } from "../Constants/RegistrationPageOptions.js";
import { GroupPageOptions } from "../Constants/RegistrationPageOptions.js";
import { registrationType } from "../Constants/RegistrationType.js";
import { useState, useEffect } from "react";
import { setWeek } from "date-fns";


// The values are the event table's camp_type verbatim — they are sent to /getevents as
// selectedEvents and compared against camp_type there, so the label is the only part free to differ.
const CAMP_TYPE_OPTIONS = [
   { value: "Junior Camp", label: "Junior Camp" },
   { value: "Youth Camp",  label: "Youth Camp"  },
   { value: "Deaf Camp",   label: "Deaf Camp"   }
]

const RETREAT_OPTION = { value: "Retreat", label: "Retreats" }

function CampEventAndDateSelection({eventRegistrationType, campEventSelection, setCampEventSelection,
   weekSelection, setWeekSelection, eventAndDate, setEventAndDate, selectedPage, setSelectedPage}) {

const [selectedEvent, setSelectedEvent] = useState("");
const [queriedEvents, setQueriedEvents] = useState([]);
const [nextPage,           setNextPage] = useState()

// Retreats are offered to groups only. Individuals already reach retreats through the "Retreats"
// tile on RegistrationCampSelection → /retreatregistration, which renders the RetreatConfig-driven
// forms; CombinationPageOptions.PersonalInfo would hand them the camp medical and consent forms.
const selectableCampTypes = eventRegistrationType === registrationType.CombinationGroup
   ? [...CAMP_TYPE_OPTIONS, RETREAT_OPTION]
   : CAMP_TYPE_OPTIONS

// Get Events
const getEvents = async () => {

   console.log("selected Dropdown" , selectedEvent)
   if (selectableCampTypes.some(campType => campType.value === selectedEvent))
   {
      try {
         const response = await fetch('/getevents', {
         method: 'POST',
         headers: { "Content-Type": "application/json" },
         body: JSON.stringify({ selectedEvents: [selectedEvent] })
      })
   
      const campEvents = await response.json();
      setQueriedEvents(campEvents.data);
      console.log(campEvents, "Here is what is returned from the database")
         
      } catch (error) {
         console.log(error)
      }

      if(eventRegistrationType === registrationType.Combination){
         setNextPage(CombinationPageOptions.PersonalInfo)
         console.log("next page set to join group", CombinationPageOptions.JoinGroup);
     }

     if(eventRegistrationType === registrationType.CombinationGroup){
        // Fast Track is priced and worded for a week of camp — a $100 hold, a free counselor week,
        // spots held until Feb 28 — so retreats skip that step and go straight to spot selection.
        setNextPage(selectedEvent === RETREAT_OPTION.value
           ? GroupPageOptions.ReservationSpotSelection
           : GroupPageOptions.ReservationTypeSelection)
     }
   }
   else
   {
      setQueriedEvents('');
      console.log("next page not even set!")
   }
}

useEffect(() => {
   getEvents()
 }, [selectedEvent]);

useEffect(() => {
   console.log(eventRegistrationType, nextPage, "The missing items!")
}, [nextPage]);

return (
<div className="regPage1Content">
   <div className="regPageContainer">
      <form>    
            <div className="selectEventHeading">
               Select Your Week 
            </div>
            
            <div className="selectEvent">
               <div className="selectEventLabel">  
                  <label>Camp Type</label>
               </div>

               <div className="selectEventDropdown">
                  <select
                     value = {selectedEvent}
                     onChange={event => { {setSelectedEvent(event.target.value)}
                     }}>
                     <option value="Select Camp Type">Select Camp Type</option>
                     {selectableCampTypes.map(campType => (
                        <option key={campType.value} value={campType.value}>
                           {campType.label}
                        </option>
                     ))}
                  </select>
               </div>
            </div>

            <div className="eventCardList">
            {Array.isArray(queriedEvents) && (
               <EventCardList  eventRegistrationType = {eventRegistrationType} 
                               campEvents            = {queriedEvents} 
                               setWeekSelection      = {setWeekSelection} 
                               nextPage              = {nextPage}
                               setSelectedPage       = {setSelectedPage}/>)}
            </div>
      </form>
   </div>
</div>
)
}

export default CampEventAndDateSelection;
